import { api, getCurrentLanguage } from './api';

const getUserMenus = async (params = {}) => {
    const customerId = params?.customerId;
    const language = getCurrentLanguage();
    const response = await api({
        url: 'Menus/getUserMenu',
        method: 'GET',
        id: `Menus-getUserMenu-${customerId || 'default'}-${language}`,
        params: customerId ? { customerId } : undefined,
        cache: {
            ttl: 24 * 60 * 60 * 1000
        },
    });
    return response.data;
};

const getAdminUserMenus = async () => {
    const language = getCurrentLanguage();
    const response = await api({
        url: 'Menus/getAdminUserMenu',
        method: 'GET',
        id: `Menus-getAdminUserMenu-${language}`,
        cache: {
            ttl: 2 * 60 * 1000
        },
    });
    return response.data;
};

const getAllUserMenu = async () => {
    const language = getCurrentLanguage();
    const response = await api({
        url: 'Menus/getAllUserMenu',
        method: 'GET',
        id: `Menus-getAllUserMenu-${language}`,
        cache: {
            ttl: 2 * 60 * 1000
        },
    });
    return response.data;
};

const menusServices = {
  getUserMenus,
  getAllUserMenu,
  getAdminUserMenus,
};

export default menusServices;
